module.exports = __webpack_public_path__ + "static/media/24UHCHR15.9d98d4e8.jpg";